var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"uuid-7a60a04b-2503-4696-a6e2-ab88d4edabbf","d":"M35.62,12.45H9.38c-.5,0-.91,.41-.91,.91V31.41c0,.5,.41,.91,.91,.91h26.24c.5,0,.91-.41,.91-.91V13.35c0-.5-.41-.91-.91-.91Zm-13.11,11.22L11.78,14.26h21.43l-10.71,9.41Zm-4.22-1.29l-8.01,7.03V15.35l8.01,7.03Zm1.37,1.21l2.24,1.97c.17,.15,.39,.23,.6,.23s.43-.08,.6-.23l2.24-1.97,7.87,6.91H11.78l7.89-6.91Zm7.05-1.21l8-7.03v14.05l-8-7.03Z","fill":"#fff"}));
}

Mail.displayName = "Mail";

Mail.defaultProps = {"id":"uuid-b2b4801b-3848-4634-9a55-bb4c03bd42e3","viewBox":"0 0 45 45"};

module.exports = Mail;

Mail.default = Mail;
